import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { TrailerStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('trailer', reducer),
        EffectsModule.forFeature([TrailerStoreEffects])
    ],
    providers: []
})
export class TrailerStoreModule {}
